import React from "react";
import InfoCard from "../components/InfoCard";
import SectionHeading from "../components/SectionHeading";
import siteContent from "../config/siteContent";
import { aboutImages } from "../config/images";

/**
 * About page
 * Props:
 *  - content: siteContent.about
 */
function About({ content }) {
  const vision = siteContent.vision;

  return (
    <>
      <section className="hero-section py-5">
        <div className="container text-center">
          <h1 className="fw-bold display-6 mb-2">{content.title}</h1>
          <p className="lead mx-auto" style={{ maxWidth: "700px" }}>{content.intro}</p>
        </div>
      </section>

      {/* VISION */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img src={aboutImages.history} alt="Community heritage" className="img-fluid rounded-4 shadow-sm" />
            </div>
            <div className="col-lg-6">
              <div className="section-title-eyebrow text-orange mb-2">Our Vision</div>
              <h2 className="fw-bold text-navy mb-3">{vision.heading}</h2>
              <div className="divider-brand mb-3"></div>
              <p className="text-secondary">{vision.statement}</p>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section className="section bg-white">
        <div className="container">
          <SectionHeading eyebrow="Our Purpose" title={content.mission.heading} subtitle={content.mission.text} />
        </div>
      </section>

      {/* VALUES */}
      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="What guides us" title="Our Core Values" />
          <div className="row g-4">
            {content.values.map((item, idx) => (
              <div className="col-md-6 col-lg-3" key={idx}>
                <InfoCard icon={item.icon} title={item.title} text={item.text} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HISTORY */}
      <section className="section bg-navy text-white">
        <div className="container text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <div className="section-title-eyebrow text-saffron mb-2">Our Story</div>
          <h2 className="fw-bold mb-3">How APKANZ Began</h2>
          <div className="divider-brand mx-auto mb-3"></div>
          <p className="text-white-50">{content.history}</p>
        </div>
      </section>
    </>
  );
}

export default About;
